import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import SampleManagerApiHealthCheck from './Admin/SampleManagerApiHealthCheck';
import SampleManagerApiPingCheck from './Admin/SampleManagerApiPingCheck';

const Admin = () => {
    const tiles = [
        <SampleManagerApiHealthCheck />,
        <SampleManagerApiPingCheck/>
    ]

    return (
        <Container>
            <Row xs={1} md={2} lg={3} xl={4}>
                {tiles.map((card, index) =>
                    <Col className="pt-2" key={`tile-${index}`}>
                        {card}
                    </Col>
                )}
            </Row>
        </Container>
    );
}

export default Admin